<template>
  <!-- tree starts -->
  <ul :class="'tmf-tree-anchor ps-0' + patid" v-for="elem in list" :key="elem.id">
    <li>       
      <div class="d-flex">
        <label
        @click.prevent="getFolderChildren(elem.id)"
          class="tmf-folder-label " :id="`etmfModal-`+ elem.id"
          :class="currentselectedfolder == elem.id ? 'tmf-tree-label tmf-bold-font' : 'tmf-tree-label'"          
          ><span class="mr-2" >{{ elem.name }}</span>   
        </label>                            
      </div> 
      <div v-if="showTreeLoader[elem.id]==true && folderswitch[elem.id]==true">
        <img src="../../assets/img/loading.gif" width="15"  alt="Waiting for login" />
      </div>
      <div v-else> 
        <TreeMove
        class="modify-block"
        v-if="folderswitch[elem.id]"
        :openfolderlist="openfolder" 
        :showLoader="showTreeLoader[elem.id]"
        :patid="elem.id"
        :list="foldertreelist[elem.id]"
        :boldfolder ="boldfolder"
        >
        </TreeMove>
      </div>
    </li>  
  </ul>
</template>

<script src="./TreeMove.js"></script>

<style  scoped>


.tmf-tree-label{
  display: flex;
  -webkit-box-align: center;
  -webkit-align-items: center;
  align-items: center;
  padding: 0.3em 0.5em;
  position:relative;
  margin-bottom: 0;
}
.tmf-tree-line:hover{
  background-color:#f0f0f0;
  cursor:pointer;
}
.tmf-tree-label:before{
  color: #fff;
  position: relative;
  z-index: 1;
  float: left;
  margin: 0 0.5em 0 -2em;
  width: 1em;
  height: 1em;
  border-radius: 1em;
  content: url("../../assets/images/folder-close.png");
  text-align: center;
  line-height: .8em;
}
.myStyle {
  color: blue;
}
.tmfshowHide {
  display: block;
}
.tmf-bold-font {
  font-weight:bold;
}
span ul li:hover .more-option-icon {
  display: block;
}
.selected {
  display: none ;
}
/* CSS Popover Styles */

.tmf-ellipsis-btn{
    anchor-name:--manage-btn;
    border:0;
  }
  .tmf-popup-menu {
    position:absolute;
    inset: auto;
    text-align: left;
    border-radius: 5px;
    border: 1px solid #e7eaec;
    background-color: rgba(255, 255, 255, 1);
    box-shadow: 3px 3px 3px rgba(160, 160, 160, 0.5);
    z-index: 200;
  }
  .tmf-popup-menu{
    top:anchor(bottom);
    right:anchor(left);
    width:fit-content;
    margin-inline-end: 5px;
  }
  .tmf-popup-menu{
    position-try-fallbacks: --bottom;
    top:anchor(bottom);
    right:anchor(right);
    width:160px;
  }
  .tmf-popup-menu> button{
    width:100%;
    border:0;
    font-size:0.8rem;
    font-weight:400;
    color:rgba(0,0,0);
    padding: 0.6rem 0.8rem;
  }

  [popover]:popover-open {
    display: flex;
    flex-direction: column;
    align-items: baseline;
    animation: fadeIn 0.2s ease-in-out;
  }

  .tmf-popup-menu> .popup-menu-block:hover, .popup-submenu> div:hover{
    background-color: #e4eaf9;
  }

  @position-try --bottom{
    inset:auto;
    bottom:anchor(top);
    right:anchor(left)
  }

/* CSS Popover Styles */
</style>
